import React from "react";

import {
  FiCheck,
  FiClock,
  FiPackage,
  FiTruck,
  FiXCircle,
} from "react-icons/fi";

import {
  ORDER_STATUS_FLOW,
  ORDER_STATUS_LABELS,
} from "../utils/orderConstants";

import {
  formatDate,
} from "../utils/orderHelpers";


/* =========================================================
   STATUS ICON
========================================================= */

const getStatusIcon = (
  status
) => {
  switch (status) {
    case "pending":
      return FiClock;

    case "confirmed":
    case "processing":
    case "packed":
      return FiPackage;

    case "shipped":
    case "out_for_delivery":
      return FiTruck;

    case "delivered":
      return FiCheck;

    default:
      return FiClock;
  }
};


/* =========================================================
   FIND HISTORY RECORD
========================================================= */

const getHistoryItem = (
  history,
  status
) => {
  if (
    !Array.isArray(
      history
    )
  ) {
    return null;
  }

  return (
    history.find(
      (item) =>
        item?.status ===
        status
    ) || null
  );
};


/* =========================================================
   COMPONENT
========================================================= */

const OrderStatusTimeline = ({
  order,
}) => {
  const currentStatus =
    order?.status || "";

  const history =
    Array.isArray(
      order?.statusHistory
    )
      ? order.statusHistory
      : [];


  /* =======================================================
     CANCELLED
  ======================================================= */

  if (
    currentStatus ===
    "cancelled"
  ) {
    const cancelledHistory =
      getHistoryItem(
        history,
        "cancelled"
      );


    return (
      <div
        className="order-timeline-special cancelled"
      >
        <div
          className="order-timeline-special-icon"
        >
          <FiXCircle />
        </div>

        <div>
          <strong>
            Order Cancelled
          </strong>

          <span>
            {formatDate(
              cancelledHistory
                ?.changedAt ||
              order?.cancelledAt
            )}
          </span>

          {order
            ?.cancellationReason ? (
            <p>
              {
                order
                  .cancellationReason
              }
            </p>
          ) : null}
        </div>
      </div>
    );
  }


  /* =======================================================
     RETURNED
  ======================================================= */

  if (
    currentStatus ===
    "returned"
  ) {
    const returnHistory =
      getHistoryItem(
        history,
        "returned"
      );


    return (
      <div
        className="order-timeline-special returned"
      >
        <div
          className="order-timeline-special-icon"
        >
          <FiPackage />
        </div>

        <div>
          <strong>
            Order Returned
          </strong>

          <span>
            {formatDate(
              returnHistory
                ?.changedAt ||
              order?.returnedAt
            )}
          </span>

          {order
            ?.returnReason ? (
            <p>
              {
                order
                  .returnReason
              }
            </p>
          ) : null}
        </div>
      </div>
    );
  }


  /* =======================================================
     CURRENT INDEX
  ======================================================= */

  const currentIndex =
    ORDER_STATUS_FLOW.indexOf(
      currentStatus
    );


  return (
    <div
      className="order-status-timeline"
    >
      {ORDER_STATUS_FLOW.map(
        (
          status,
          index
        ) => {
          const Icon =
            getStatusIcon(
              status
            );


          const historyItem =
            getHistoryItem(
              history,
              status
            );


          const completed =
            currentIndex >=
            index;


          const current =
            currentStatus ===
            status;


          const pending =
            currentIndex <
            index;


          return (
            <div
              key={
                status
              }
              className={`order-timeline-item ${
                completed
                  ? "completed"
                  : ""
              } ${
                current
                  ? "current"
                  : ""
              } ${
                pending
                  ? "pending"
                  : ""
              }`}
            >
              {/* ===========================================
                  LEFT
              =========================================== */}

              <div
                className="order-timeline-left"
              >
                <div
                  className="order-timeline-icon"
                >
                  {completed ? (
                    <FiCheck />
                  ) : (
                    <Icon />
                  )}
                </div>


                {index <
                ORDER_STATUS_FLOW.length -
                  1 ? (
                  <div
                    className="order-timeline-line"
                  />
                ) : null}
              </div>


              {/* ===========================================
                  CONTENT
              =========================================== */}

              <div
                className="order-timeline-content"
              >
                <strong>
                  {
                    ORDER_STATUS_LABELS[
                      status
                    ]
                  }
                </strong>


                {historyItem
                  ?.changedAt ? (
                  <span>
                    {formatDate(
                      historyItem
                        .changedAt
                    )}
                  </span>
                ) : current ? (
                  <span>
                    Current status
                  </span>
                ) : (
                  <span>
                    Pending
                  </span>
                )}


                {historyItem
                  ?.note ? (
                  <p>
                    {
                      historyItem
                        .note
                    }
                  </p>
                ) : null}


                {historyItem
                  ?.changedBy ? (
                  <small>
                    Updated by{" "}
                    {historyItem
                      ?.changedBy
                      ?.name ||
                      historyItem
                        ?.changedBy
                        ?.email ||
                      "Admin"}
                  </small>
                ) : null}
              </div>
            </div>
          );
        }
      )}
    </div>
  );
};


export default
  OrderStatusTimeline;